var AddToCompareButtonComponentController = (function () {
    function AddToCompareButtonComponentController(compareChannel, dictionary) {
        this.compareChannel = compareChannel;
        this.dictionary = dictionary;
    }
    AddToCompareButtonComponentController.prototype.$onInit = function () {
        var _this = this;
        this.tooltipOpened = false;
        this.compareChannel
            .onAdd()
            .then(null, null, function (group) {
            if (_this.addedToCompare) {
                return;
            }
            _this.addedToCompare = _this.group.groupId === group.groupId;
            _this.setTooltipTranslation();
        });
        this.compareChannel
            .onRemove()
            .then(null, null, function (group) {
            if (!_this.addedToCompare) {
                return;
            }
            _this.addedToCompare = !(_this.group.groupId === group.groupId);
            _this.setTooltipTranslation();
        });
        this.compareChannel
            .onReset()
            .then(null, null, function () {
            _this.addedToCompare = false;
            _this.setTooltipTranslation();
        });
        this.addedToCompare = this.compareChannel.get().some(function (g) { return g.groupId === _this.group.groupId; });
        this.setTooltipTranslation();
    };
    AddToCompareButtonComponentController.prototype.toggleCompareState = function () {
        if (this.addedToCompare) {
            this.compareChannel.remove(this.group);
        }
        else {
            this.compareChannel.add(this.group);
        }
        this.tooltipOpened = false;
    };
    AddToCompareButtonComponentController.prototype.setTooltipTranslation = function () {
        var _this = this;
        var dictionaryKey = this.addedToCompare ? 'RemoveFromCompare' : 'AddToCompare';
        this.dictionary.get(dictionaryKey).then(function (translation) {
            _this.tooltip = translation;
        });
    };
    AddToCompareButtonComponentController.$inject = ['compareChannel', 'contentDictionary'];
    return AddToCompareButtonComponentController;
}());
export var AddToCompareButtonComponent = {
    bindings: {
        group: '<',
    },
    controller: AddToCompareButtonComponentController,
    template: "\n    <cg-icon cg-icon-interactive             \n             class=\"cg-icon-rounded cg-icon-rounded-size-30 cg-icon-size-20\" \n             ng-class=\"{ 'active': $ctrl.addedToCompare }\" \n             uib-tooltip=\"{{ $ctrl.tooltip }}\"\n             tooltip-is-open=\"$ctrl.tooltipOpened\"\n             tooltip-placement=\"bottom\"\n             ng-click=\"$ctrl.toggleCompareState()\">\n             content_copy\n    </cg-icon>\n  ",
};
